import React from 'react';

import { type Product } from 'generated/graphql';
import { formatPrice } from 'utils';

import Image from 'components/Image/Image';

import styles from './Details.module.scss';

interface Props {
  item?: Product | undefined;
  visible?: boolean;
  dietaryEnums: string[]; // eslint-disable-line react/no-unused-prop-types
}

const General: React.FC<Props> = ({ item, visible }) => {
  if (!item) {
    return null;
  }

  const { description, variablesByApp, dietary } = item;

  return (
    <ul className={`${styles.General} ${visible ? styles.Visible : ''}`} data-testid="general-container">
      {variablesByApp && (
        <li>
          <h4 data-testid="general-title">Price{variablesByApp.length === 1 ? '' : 's'}</h4>
          <div>
            <ul className={styles.Prices} data-testid="general-pricing">
              {variablesByApp.map((appPrice) => {
                const { price, app } = appPrice;

                return (
                  <li key={app.id} data-testid="general-price-by-app">
                    {app.image && (
                      <div className={styles.PriceImage}>
                        <Image src={app.image} alt={app.name} fallbackUrl="/Images/NoApp.png" />
                      </div>
                    )}
                    <div className={styles.content}>{formatPrice(price)}</div>
                  </li>
                );
              })}
            </ul>
          </div>
        </li>
      )}
      {description && (
        <li>
          <h4>Description</h4>
          <div className={styles.content}>{description}</div>
        </li>
      )}
      {dietary.length > 0 && (
        <li>
          <h4>Nutritional Tags</h4>
          <div>
            <ul>
              {dietary.map((dietaryItem) => {
                return (
                  <li data-testid="general-dietary" key={dietaryItem}>
                    <span className={styles.content}>{dietaryItem}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </li>
      )}
    </ul>
  );
};

export default General;
